// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormEditExpenseType } from '../../forms/FormEditExpenseType/FormEditExpenseType';

// props
export interface DialogEditExpenseTypeProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogEditExpenseType = ({
	isOpen,
	onClose,
	onSuccess,
}: DialogEditExpenseTypeProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('saveExpenseType'),
					loading: isLoading,
					form: 'form-edit-expense-type',
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={400}
			onClose={onClose}
			title={{
				children: t('editExpenseType'),
				variant: 'h3',
			}}>
			<FormEditExpenseType onClose={onClose} onSuccess={onSuccess} setIsLoading={setIsLoading} />
		</DialogActions>
	);
};
